app.modules.visuallyImpairedVersion = ((self = {}) => {
  const _mainMenu = document.querySelector('.js-main-menu');
  const _toolbar = document.querySelector('.js-toolbar-container');

  function _toggleVisuallyImpairedPanel() {
    document.body.classList.toggle('visually-impaired-panel-show');
    if (_mainMenu) {
      _mainMenu.classList.toggle('main-menu_visually-impaired_open');
      _toolbar.classList.toggle(
        'main-header__toolbar-container_visually-impaired_open'
      );
    }
  }

  function _checkTarget(evt) {
    const target = evt.target;
    if (
      target.classList.contains('bvi-open') ||
      target.classList.contains('bvi-panel-close')
    ) {
      _toggleVisuallyImpairedPanel();
    }
  }

  function getCookie(name) {
    let matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          // eslint-disable-next-line no-useless-escape
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)'
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  function _addListeners() {
    document.addEventListener('click', _checkTarget, true);
  }

  function _init() {
    const visuallyImpairedPanel = document.querySelector('.bvi-panel');
    if (getCookie('bvi-panel-hide') && visuallyImpairedPanel) {
      _toggleVisuallyImpairedPanel();
    }
    _addListeners();
  }

  self.load = _init;
  return self;
})(app.modules.visuallyImpairedVersion);
